export const LOCALE_PREFIX = 'components.Tooltips.Indicators.PaymentIndexTooltip'
